'use client';

import { PrudsysBrandToProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysBrandToProductsRecoSlider/PrudsysBrandToProductsRecoSlider.client';
import { SimilarProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SimilarProductsRecoSlider/SimilarProductsRecoSlider.client';
import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';

export type AbcTestVariants = 'control' | 'testA' | 'testB' | undefined;

export type ProductRecoPrudsysBrandToProductsAbTestWrapperProps = {
  orderNumber: string;
  promotion: string;
  brandName: string;
  brandId: string;
  defaultCategory: string;
  title?: string;
  abTest: {
    isAbcTestActive: boolean;
    variant: AbcTestVariants;
    testId: string;
  };
};

/**
 *
 * TODO: PACE-1203 please remove this when abc test is finished.
 */
export const ProductRecoPrudsysBrandToProductsAbTestWrapper = ({
  orderNumber,
  promotion,
  title,
  brandName,
  brandId,
  defaultCategory,
  abTest,
}: ProductRecoPrudsysBrandToProductsAbTestWrapperProps) => {
  const { setOutcome, setRelevantProduct } = useAbTesting();

  const { isAbcTestActive, testId, variant } = abTest;
  const activeVariant: AbcTestVariants = isAbcTestActive ? variant : 'control';

  const trackSeen = () => setOutcome(testId, { SEEN_RECO: 1 });
  const trackClick = (akl: string, groupName: string) => {
    setRelevantProduct(testId, akl, groupName);
    setOutcome(testId, { COF: 1 });
  };

  const similarProducts = (
    <SimilarProductsRecoSlider
      productId={`${orderNumber}${promotion}`}
      fetchOnThreshold
      title={title ?? ''}
      onSeen={trackSeen}
      onProductClick={(akl) => trackClick?.(akl, 'SIMILAR')}
    />
  );

  const brandToProducts = (
    <PrudsysBrandToProductsRecoSlider
      brand={brandName}
      brandId={brandId}
      categoryIds={[defaultCategory]}
      productId={orderNumber}
      fetchOnThreshold
      title=""
      onSeen={trackSeen}
      onProductClick={(akl) => trackClick?.(akl, 'BRAND2PRODUCTS')}
    />
  );

  switch (activeVariant) {
    case 'testA':
      return (
        <div>
          {similarProducts}
          {brandToProducts}
        </div>
      );
    case 'testB':
      return <div>{brandToProducts}</div>;
    case 'control':
    default:
      return <div>{similarProducts}</div>;
  }
};
